import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ToolKey } from '../../api/premiumService';

type Props = {
  id: ToolKey;
  icon: React.ComponentType<any>;
  titleKey: string;
  descKey: string;
  selected: boolean;
  quota: number;
  onClick: () => void;
};

const ToolListItem: React.FC<Props> = ({
  icon: Icon, titleKey, descKey, selected, quota, onClick,
}) => {
  const { t } = useTranslation();

  const base =
    'relative w-full text-left rounded-2xl p-4 transition ' +
    'flex items-start gap-3 min-h-[88px] ' +
    'bg-white border border-slate-300/60 overflow-hidden ' +
    // ⬇️ quita el halo azul de foco del navegador
    'focus:outline-none focus-visible:outline-none focus:ring-0';

  const selectedCls = selected
    // borde azul + sombra inset suave (sin ring externo)
    ? 'border-sky-300 shadow-[inset_0_0_0_2px_rgba(2,132,199,0.25)]'
    : 'shadow-sm hover:shadow-md hover:border-slate-400';

  return (
    <button onClick={onClick} className={`${base} ${selectedCls}`}>
      {/* Indicador izquierdo, separado 2px de los bordes para no chocar con el radio */}
      {selected && (
        <span
          className="absolute left-0 top-0.5 bottom-0.5 w-1.5 rounded-l-2xl
                     bg-gradient-to-b from-sky-500 to-indigo-600"
          aria-hidden
        />
      )}

      <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-sky-600 to-indigo-600 text-white flex items-center justify-center shrink-0 shadow-sm">
        <Icon className="h-5 w-5" />
      </div>

      {/* Texto con padding para no chocar con el badge */}
      <div className="min-w-0 flex-1 pr-12">
        <div className="font-semibold text-slate-900 whitespace-normal break-words leading-snug line-clamp-2">
          {t(titleKey)}
        </div>
        <div className="mt-1 text-[13px] leading-snug text-slate-600 line-clamp-2">
          {t(descKey)}
        </div>
      </div>

      {/* Badge de cuota */}
      <div
        className={[
          'absolute right-4 top-4 rounded-full px-2.5 py-0.5 text-[11px] font-semibold shadow-sm ring-1',
          quota > 0 ? 'bg-slate-900 text-white ring-black/10' : 'bg-rose-50 text-rose-700 ring-rose-200',
        ].join(' ')}
        title={t('premium.exec_count_label') as string}
        aria-label={t('premium.exec_count_label') as string}
      >
        {quota}
      </div>
    </button>
  );
};

export default ToolListItem;
